// navegacion
import completeNavigation from "./barraNavegacion/BotonContinuarEntendidoSiguiente.mp3"
import navigationHomePause from "./barraNavegacion/BotonHomePause.mp3"
import navigationInfo from "./barraNavegacion/BotonInformacionpista.mp3"
import navigationMedallas from "./barraNavegacion/BotonMedallas.mp3"
import navigationOut from "./barraNavegacion/BotonSalir.mp3"

// escenas
import homeScene from "./escenarios/escenariohome.mp3"
import cityScene from "./escenarios/Escenariociudad.mp3"
import onOxxoScene from "./escenarios/Escenariodentrooxxo.mp3"
import activityScene from "./escenarios/Escenariorealizacionactividad.mp3"
import selectCharacterScene from "./escenarios/Escenarioseleccionapersonaje.mp3"

// card
import cardFine from "./audiosCards/Cardactividadbienhecho.wav"
import cardLock from "./audiosCards/Cardactividadbloqueada.wav"
import cardComplete from "./audiosCards/Cardactividadcompletadaproceso.wav"
import cardMalHecho from "./audiosCards/Cardactividadmalhecho.mp3"
import cardFinalTeam from "./audiosCards/Cardfinaltema.wav"
import cardTeamBlock from "./audiosCards/Cardsubtemabloqueado.wav"
import cardProcess from "./audiosCards/Cardsubtemacompletadoproceso.wav"
import cardPointComplete from "./audiosCards/Cardsubtemapuntossuficientes.wav"
import cardPointNotComplete from "./audiosCards/Cardsubtemasinpuntossuficientes.mp3"

// gestos
import gestoAvazar from "./gestos/Seleccionaavanzar.wav"
import gestoInformacion from "./gestos/Seleccionainformacion.wav"
import gestoLimpia from "./gestos/Seleccionalimpia.wav"
import gestoRespuesta from "./gestos/Seleccionarespuesta.wav"
import gestoLugar from "./gestos/Seleccionaunlugar.wav"
import gestoObjeto from "./gestos/Seleccionaunobjeto.wav"
import gestoPersonaje from "./gestos/Seleccionaunpersonaje.wav"

//* voces
import { voicesGlobal } from './voces'


export const audiosAssets = {
	barraNavegacion: {
		completeNavigation,
		navigationHomePause,
		navigationInfo,
		navigationMedallas,
		navigationOut
	},
	escenarios: {
		homeScene,
		cityScene,
		onOxxoScene,
		activityScene,
		selectCharacterScene
	},
	cards: {
		cardFine,
		cardLock,
		cardComplete,
		cardMalHecho,
		cardFinalTeam,
		cardTeamBlock,
		cardProcess,
		cardPointComplete,
		cardPointNotComplete
	},
	gestos: {
		gestoAvazar,
		gestoInformacion,
		gestoLimpia,
		gestoRespuesta,
		gestoLugar,
		gestoObjeto,
		gestoPersonaje,
	},
	voices: {
		voicesGlobal
	}
}